import { useMasking } from './MaskingProvider.jsx';

const MASK_MAP = {
  '1': 'I',
  '2': 'S',
  '3': 'E',
  '4': 'A',
  '5': 'Q',
  '6': 'G',
  '7': 'L',
  '8': 'B',
  '9': 'P',
  '0': 'X'
};

export const maskValue = (value) => {
  if (value === null || value === undefined) return value;
  return String(value).replace(/[0-9]/g, (digit) => MASK_MAP[digit] || digit);
};

export const MaskedValue = ({ children, value, ...props }) => {
  const { isMasked } = useMasking();
  
  // Use value prop if provided, otherwise use children
  const displayValue = value !== undefined ? value : children;
  
  if (!isMasked) {
    return <span {...props}>{displayValue}</span>;
  }
  
  return <span {...props}>{maskValue(displayValue)}</span>;
};

// Specialized components for common use cases
export const MaskedCurrency = ({ value, ...props }) => {
  const { isMasked } = useMasking();
  
  // Format currency with proper thousands separators and dollar sign.
  // Negatives use accounting parens, e.g. ($19,000.00), to match the rest of the app.
  const formatCurrency = (val) => {
    const num = parseFloat(val || 0);
    const isNegative = num < 0;
    const abs = Math.abs(num).toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
    return isNegative ? `($${abs})` : `$${abs}`;
  };
  
  if (!isMasked) {
    return <span {...props}>{formatCurrency(value)}</span>;
  }
  
  // For masked display, format first then mask
  const formattedValue = formatCurrency(value);
  return <span {...props}>{maskValue(formattedValue)}</span>;
};

export const MaskedNumber = ({ value, decimals = 0, ...props }) => {
  const { isMasked } = useMasking();
  
  if (!isMasked) {
    const num = parseFloat(value || 0);
    return <span {...props}>{num.toLocaleString('en-US', { 
      minimumFractionDigits: decimals, 
      maximumFractionDigits: decimals 
    })}</span>;
  }
  
  const num = parseFloat(value || 0);
  const formattedValue = num.toLocaleString('en-US', { 
    minimumFractionDigits: decimals, 
    maximumFractionDigits: decimals 
  });
  return <span {...props}>{maskValue(formattedValue)}</span>;
};